import axios from 'axios';
import Environment from '../../utils/Environment';

const getTableHeaders = async (
  orgCode: string,
  env: string,
  group: string,
  subGroup: string
): Promise<string[]> => {
  try {
    const baseURL = Environment.getTableHeadersAPI();
    
    if (!baseURL) {
      return [];
    }
    
    if (!orgCode || !group || !subGroup) {
      return [];
    }
    
    const apiURL = `${baseURL}?dcCode=${encodeURIComponent(orgCode)}&group=${encodeURIComponent(group)}&sub=${encodeURIComponent(subGroup)}`;
    const response = await axios.get<string[]>(apiURL);
    if (response.data && Array.isArray(response.data)) {
      return response.data;
    }
    return [];
  } catch (err: any) {
    if (err.response) {    
    }
    return [];
  }
};

export default getTableHeaders;
